import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import "bootstrap-daterangepicker/daterangepicker.css";
import { Doughnut } from "react-chartjs-2";
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  BarElement,
  PointElement,
  LineElement,
  ArcElement,
  Title,
  Tooltip,
  Legend,
} from "chart.js";
// import { all_routes } from '../../../Router/all_routes';
// import PredefinedDateRanges from "../../../../core/common/range-picker/datePicker";
import OverView from "./OverView";
import CRMCalendar from "./Calendar";
import CRMTimeLine from "./TimeLIne";
import AllTabs from "./AllTabs";
import CRMToDo from "./ToDo";
import { Skeleton } from "antd";
import { BASE_CRM_URL } from "../../../components/config/config";

// Register the necessary components for Chart.js
ChartJS.register(
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  BarElement,
  ArcElement,
  Title,
  Tooltip,
  Legend,
);

const CRMDashboard = () => {
  const [dashboardLoading, setDashboardLoading] = useState(true);

  const [dashboardCounts, setDashboardCounts] = useState({
    invoicesAwaitingPayment: 0,
    convertedLeads: 0,
    projectsInProgress: 0,
    tasksNotFinished: 0,
  });

  const [leadsGraph, setLeadsGraph] = useState({
    new: 0,
    followUp: 0,
    quoteSent: 0,
    noAnswer: 0,
  });

  const [projectGraph, setProjectGraph] = useState({
    inProgress: 0,
    notStarted: 0,
    finished: 0,
    cancelled: 0,
  });

  const getDashboardStatistics = async () => {
    try {
      setDashboardLoading(true);

      const response = await fetch(
        `${BASE_CRM_URL}dashboard/GetDashboardStatistics`,
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
          },
        },
      );

      if (!response.ok) {
        throw new Error(`HTTP error! Status: ${response.status}`);
      }

      const data = await response.json();

      if (data?.Status && data?.ResultData) {
        const result = data.ResultData;

        setDashboardCounts({
          invoicesAwaitingPayment:
            result?.DashboardCounts?.invoices_awaiting_payment ?? 0,

          convertedLeads: result?.DashboardCounts?.converted_leads ?? 0,

          projectsInProgress:
            result?.DashboardCounts?.projects_in_progress ?? 0,

          tasksNotFinished: result?.DashboardCounts?.tasks_not_finished ?? 0,
        });

        setLeadsGraph({
          new: result?.LeadsGraph?.New ?? 0,
          followUp: result?.LeadsGraph?.Follow_Up ?? 0,
          quoteSent: result?.LeadsGraph?.Quote_Sent ?? 0,
          noAnswer: result?.LeadsGraph?.No_Answer ?? 0,
        });

        setProjectGraph({
          inProgress: result?.ProjectGraph?.InProgress ?? 0,
          notStarted: result?.ProjectGraph?.New ?? 0,
          finished: result?.ProjectGraph?.Finished ?? 0,
          cancelled: result?.ProjectGraph?.Cancelled ?? 0,
        });
      }
    } catch (error) {
      console.error("Error fetching dashboard statistics:", error);
    } finally {
      setDashboardLoading(false);
    }
  };

  useEffect(() => {
    getDashboardStatistics();
  }, []);

  const leadsOverviewData = {
    labels: ["New", "FollowUp", "Quote Sent", "NoAnswer"],

    datasets: [
      {
        data: [
          leadsGraph?.new,
          leadsGraph?.followUp,
          leadsGraph?.quoteSent,
          leadsGraph?.noAnswer,
        ],

        backgroundColor: ["#E04F16", "#092C4C", "#94e66c", "#FE9F43"],

        borderWidth: 5,
        borderRadius: 10,
        hoverBorderWidth: 4,
        cutout: "50%",
      },
    ],
  };

  const leadsOverviewOption = {
    responsive: true,
    maintainAspectRatio: false,

    layout: {
      padding: {
        top: -20,
        bottom: -20,
      },
    },

    plugins: {
      legend: {
        display: false,
      },

      tooltip: {
        callbacks: {
          label: function (tooltipItem) {
            return ` ${tooltipItem.raw}`;
          },
        },
      },
    },
  };

  const projectStatsData = {
    labels: ["In Progress", "Not Started", "Finished", "Cancelled"],

    datasets: [
      {
        data: [
          projectGraph?.inProgress,
          projectGraph?.notStarted,
          projectGraph?.finished,
          projectGraph?.cancelled,
        ],

        backgroundColor: ["#092C4C", "#E04F16", "#FE9F43", "#94e66c"],

        borderWidth: 5,
        borderRadius: 10,
        hoverBorderWidth: 4,
        cutout: "50%",
      },
    ],
  };

  const projectStatsOption = {
    responsive: true,
    maintainAspectRatio: false,

    layout: {
      padding: {
        top: -20,
        bottom: -20,
      },
    },

    plugins: {
      legend: {
        display: false,
      },

      tooltip: {
        callbacks: {
          label: function (tooltipItem) {
            return ` ${tooltipItem.raw}`;
          },
        },
      },
    },
  };

  return (
    <div className="page-wrapper">
      <div className="content">
        {/* <div className="d-flex align-items-center justify-content-between flex-wrap gap-3 mb-2">
          <div className="mb-3">
            <h1 className="mb-1">CRM</h1>
            <p className="fw-medium">
              Total Leads <span className="text-primary fw-bold">76</span> ,
              Today
            </p>
          </div>
          <div className="input-icon-start position-relative mb-3">
            <span className="input-icon-addon fs-16 text-gray-9">
              <i className="ti ti-calendar" />
            </span>
            <PredefinedDateRanges />
          </div>
        </div> */}

        <div className="row">
          {/* Invoices */}
          <div className="col-xl-3 col-sm-6 col-12 d-flex">
            {dashboardLoading ? (
              <div className="card sale-widget flex-fill">
                <div className="card-body d-flex align-items-center">
                  <Skeleton.Avatar active shape="square" size={50} />

                  <div className="ms-3 flex-fill">
                    <Skeleton
                      active
                      title={{
                        width: "75%",
                      }}
                      paragraph={{
                        rows: 1,
                        width: "40%",
                      }}
                    />
                  </div>
                </div>
              </div>
            ) : (
              <Link className="card bg-secondary sale-widget flex-fill">
                <div className="card-body d-flex align-items-center">
                  <span className="sale-icon bg-white text-secondary">
                    <i className="fa-solid fa-file-invoice fa-lg"></i>
                  </span>

                  <div className="ms-2">
                    <p className="text-white mb-1">Pending Payment</p>

                    <div className="d-inline-flex align-items-center flex-wrap gap-2">
                      <h4 className="text-white mb-0">
                        {dashboardCounts.invoicesAwaitingPayment}
                      </h4>
                    </div>
                  </div>
                </div>
              </Link>
            )}
          </div>

          {/* Converted Leads */}
          <div className="col-xl-3 col-sm-6 col-12 d-flex">
            {dashboardLoading ? (
              <div className="card sale-widget flex-fill">
                <div className="card-body d-flex align-items-center">
                  <Skeleton.Avatar active shape="square" size={50} />

                  <div className="ms-3 flex-fill">
                    <Skeleton
                      active
                      title={{
                        width: "70%",
                      }}
                      paragraph={{
                        rows: 1,
                        width: "35%",
                      }}
                    />
                  </div>
                </div>
              </div>
            ) : (
              <Link className="card bg-teal sale-widget flex-fill">
                <div className="card-body d-flex align-items-center">
                  <span className="sale-icon bg-white text-teal">
                    <i className="fa-solid fa-arrow-trend-up fa-lg"></i>
                  </span>

                  <div className="ms-2">
                    <p className="text-white mb-1">Converted Leads</p>

                    <div className="d-inline-flex align-items-center flex-wrap gap-2">
                      <h4 className="text-white mb-0">
                        {dashboardCounts.convertedLeads}
                      </h4>
                    </div>
                  </div>
                </div>
              </Link>
            )}
          </div>

          {/* Projects */}
          <div className="col-xl-3 col-sm-6 col-12 d-flex">
            {dashboardLoading ? (
              <div className="card sale-widget flex-fill">
                <div className="card-body d-flex align-items-center">
                  <Skeleton.Avatar active shape="square" size={50} />

                  <div className="ms-3 flex-fill">
                    <Skeleton
                      active
                      title={{
                        width: "75%",
                      }}
                      paragraph={{
                        rows: 1,
                        width: "30%",
                      }}
                    />
                  </div>
                </div>
              </div>
            ) : (
              <Link className="card bg-primary sale-widget flex-fill">
                <div className="card-body d-flex align-items-center">
                  <span className="sale-icon bg-white text-primary">
                    <i className="fa-solid fa-list-check fa-lg"></i>
                  </span>

                  <div className="ms-2">
                    <p className="text-white mb-1">Projects In Progress</p>

                    <div className="d-inline-flex align-items-center flex-wrap gap-2">
                      <h4 className="text-white mb-0">
                        {dashboardCounts.projectsInProgress}
                      </h4>
                    </div>
                  </div>
                </div>
              </Link>
            )}
          </div>

          {/* Tasks */}
          <div className="col-xl-3 col-sm-6 col-12 d-flex">
            {dashboardLoading ? (
              <div className="card sale-widget flex-fill">
                <div className="card-body d-flex align-items-center">
                  <Skeleton.Avatar active shape="square" size={50} />

                  <div className="ms-3 flex-fill">
                    <Skeleton
                      active
                      title={{
                        width: "70%",
                      }}
                      paragraph={{
                        rows: 1,
                        width: "30%",
                      }}
                    />
                  </div>
                </div>
              </div>
            ) : (
              <Link className="card bg-danger sale-widget flex-fill">
                <div className="card-body d-flex align-items-center">
                  <span className="sale-icon bg-white text-danger">
                    <i className="fa-solid fa-xmark fa-lg"></i>
                  </span>

                  <div className="ms-2">
                    <p className="text-white mb-1">Tasks Not Finished</p>

                    <div className="d-inline-flex align-items-center flex-wrap gap-2">
                      <h4 className="text-white mb-0">
                        {dashboardCounts.tasksNotFinished}
                      </h4>
                    </div>
                  </div>
                </div>
              </Link>
            )}
          </div>
        </div>
        <div className="row">
          <div className="col-xxl-4 col-md-12 col-lg-4 d-flex">
            <div className="card flex-fill">
              <div className="card-header d-flex justify-content-between align-items-center flex-wrap gap-3">
                <div className="d-inline-flex align-items-center">
                  <span className="title-icon bg-soft-orange fs-16 me-2">
                    <i className="ti ti-users" />
                  </span>
                  <h5 className="card-title mb-0">Leads Overview</h5>
                </div>
                {/* <div className="dropdown">
                  <Link
                    to="#"
                    className="dropdown-toggle btn btn-sm btn-white d-flex align-items-center"
                    data-bs-toggle="dropdown"
                    aria-expanded="false"
                  >
                    <i className="ti ti-calendar me-1" />
                    Weekly
                  </Link>
                  <ul className="dropdown-menu p-3">
                    <li>
                      <Link to="#" className="dropdown-item">
                        Today
                      </Link>
                    </li>
                    <li>
                      <Link to="#" className="dropdown-item">
                        Weekly
                      </Link>
                    </li>
                    <li>
                      <Link to="#" className="dropdown-item">
                        Monthly
                      </Link>
                    </li>
                  </ul>
                </div> */}
              </div>
              <div className="card-body">
                <div className="d-flex align-items-center justify-content-between flex-wrap gap-4 mb-4">
                  <div>
                    <Doughnut
                      data={leadsOverviewData}
                      options={leadsOverviewOption}
                      style={{
                        boxSizing: "border-box",
                        height: "230px",
                        width: "200px",
                      }}
                    />
                  </div>
                  <div>
                    <div className="category-item category-primary">
                      <p className="fs-13 mb-1">New</p>

                      <h4 className="d-flex align-items-center">
                        {dashboardLoading ? (
                          <span
                            className="placeholder rounded"
                            style={{ width: "35px", height: "22px" }}
                          />
                        ) : (
                          leadsGraph?.new
                        )}
                      </h4>
                    </div>

                    <div className="category-item category-orange">
                      <p className="fs-13 mb-1">FollowUp</p>

                      <h4 className="d-flex align-items-center">
                        {dashboardLoading ? (
                          <span
                            className="placeholder rounded"
                            style={{ width: "35px", height: "22px" }}
                          />
                        ) : (
                          leadsGraph?.followUp
                        )}
                      </h4>
                    </div>

                    <div className="category-item category-secondary">
                      <p className="fs-13 mb-1">Quote Sent</p>

                      <h4 className="d-flex align-items-center">
                        {dashboardLoading ? (
                          <span
                            className="placeholder rounded"
                            style={{ width: "35px", height: "22px" }}
                          />
                        ) : (
                           leadsGraph?.quoteSent
                        )}
                      </h4>
                    </div>

                    <div className="category-item category-success">
                      <p className="fs-13 mb-1">NoAnswer</p>

                      <h4 className="d-flex align-items-center">
                        {dashboardLoading ? (
                          <span
                            className="placeholder rounded"
                            style={{ width: "35px", height: "22px" }}
                          />
                        ) : (
                          leadsGraph?.noAnswer
                        )}
                      </h4>
                    </div>
                  </div>
                </div>
                <h6 className="mb-2">Leads Statistics</h6>
                <div className="border br-8">
                  <div className="d-flex align-items-center justify-content-between border-bottom p-2">
                    <p className="d-inline-flex align-items-center mb-0">
                      <i className="ti ti-square-rounded-filled text-indigo fs-8 me-2" />
                      Total Number Of Leads
                    </p>
                    <h5>
                      {dashboardLoading ? (
                        <Skeleton.Input
                          active
                          size="small"
                          style={{ width: 35 }}
                        />
                      ) : (
                        leadsGraph?.new +
                        leadsGraph?.followUp +
                        leadsGraph?.quoteSent +
                        leadsGraph?.noAnswer
                      )}
                    </h5>
                  </div>
                  {/* <div className="d-flex align-items-center justify-content-between p-2">
                    <p className="d-inline-flex align-items-center mb-0">
                      <i className="ti ti-square-rounded-filled text-orange fs-8 me-2" />
                      Total Number Of Completed
                    </p>
                    <h5>7899</h5>
                  </div> */}
                </div>
              </div>
            </div>
          </div>
          <div className="col-xxl-4 col-md-12 col-lg-4 d-flex">
            <div className="card flex-fill">
              <div className="card-header d-flex justify-content-between align-items-center flex-wrap gap-3">
                <div className="d-inline-flex align-items-center">
                  <span className="title-icon bg-soft-orange fs-16 me-2">
                    <i className="ti ti-chart-pie" />
                  </span>

                  <h5 className="card-title mb-0">
                    Statistics by Project Status
                  </h5>
                </div>
                {/* <div className="dropdown">
                  <Link
                    to="#"
                    className="dropdown-toggle btn btn-sm btn-white d-flex align-items-center"
                    data-bs-toggle="dropdown"
                    aria-expanded="false"
                  >
                    <i className="ti ti-calendar me-1" />
                    Weekly
                  </Link>
                  <ul className="dropdown-menu p-3">
                    <li>
                      <Link to="#" className="dropdown-item">
                        Today
                      </Link>
                    </li>
                    <li>
                      <Link to="#" className="dropdown-item">
                        Weekly
                      </Link>
                    </li>
                    <li>
                      <Link to="#" className="dropdown-item">
                        Monthly
                      </Link>
                    </li>
                  </ul>
                </div> */}
              </div>
              <div className="card-body">
                <div className="d-flex align-items-center justify-content-between flex-wrap gap-4 mb-4">
                  <div>
                    <Doughnut
                      data={projectStatsData}
                      options={projectStatsOption}
                      style={{
                        boxSizing: "border-box",
                        height: "230px",
                        width: "200px",
                      }}
                    />
                  </div>
                  <div>
                    <div className="category-item category-primary">
                      <p className="fs-13 mb-1">In Progress</p>

                      <h4 className="d-flex align-items-center">
                        {dashboardLoading ? (
                          <span
                            className="placeholder rounded"
                            style={{ width: "35px", height: "22px" }}
                          />
                        ) : (
                          projectGraph?.inProgress
                        )}
                      </h4>
                    </div>

                    <div className="category-item category-orange">
                      <p className="fs-13 mb-1">Not Started</p>

                      <h4 className="d-flex align-items-center">
                        {dashboardLoading ? (
                          <span
                            className="placeholder rounded"
                            style={{ width: "35px", height: "22px" }}
                          />
                        ) : (
                          projectGraph?.notStarted
                        )}
                      </h4>
                    </div>

                    <div className="category-item category-secondary">
                      <p className="fs-13 mb-1">Finished</p>

                      <h4 className="d-flex align-items-center">
                        {dashboardLoading ? (
                          <span
                            className="placeholder rounded"
                            style={{ width: "35px", height: "22px" }}
                          />
                        ) : (
                          projectGraph?.finished
                        )}
                      </h4>
                    </div>

                    <div className="category-item category-success">
                      <p className="fs-13 mb-1">Cancelled</p>

                      <h4 className="d-flex align-items-center">
                        {dashboardLoading ? (
                          <span
                            className="placeholder rounded"
                            style={{ width: "35px", height: "22px" }}
                          />
                        ) : (
                          projectGraph?.cancelled
                        )}
                      </h4>
                    </div>
                  </div>
                </div>
                <h6 className="mb-2">Project Statistics</h6>
                <div className="border br-8">
                  <div className="d-flex align-items-center justify-content-between border-bottom p-2">
                    <p className="d-inline-flex align-items-center mb-0">
                      <i className="ti ti-square-rounded-filled text-indigo fs-8 me-2" />
                      Total Number Of Projects
                    </p>
                    <h5>
                      {" "}
                      {dashboardLoading ? (
                        <Skeleton.Input
                          active
                          size="small"
                          style={{ width: 35 }}
                        />
                      ) : (
                        projectGraph?.inProgress +
                        projectGraph?.notStarted +
                        projectGraph?.finished +
                        projectGraph?.cancelled
                      )}
                    </h5>
                  </div>
                  {/* <div className="d-flex align-items-center justify-content-between p-2">
                    <p className="d-inline-flex align-items-center mb-0">
                      <i className="ti ti-square-rounded-filled text-orange fs-8 me-2" />
                      Total Number Of Completed
                    </p>
                    <h5>7899</h5>
                  </div> */}
                </div>
              </div>
            </div>
          </div>
          <OverView />
        </div>

        <div className="row">
          <div className="col-12 col-lg-8 d-flex">
            <div className="card flex-fill">
              <AllTabs />
            </div>
          </div>
          <div className="col-12 col-lg-4 d-flex">
            <CRMToDo />
          </div>
        </div>

        <div className="row">
          <div className="col-12 col-md-12 col-lg-8 ">
            <div className="card flex-fill">
              <div className="card-header d-flex justify-content-between align-items-center flex-wrap gap-3">
                <div className="d-inline-flex align-items-center">
                  <span className="title-icon bg-soft-indigo fs-16 me-2">
                    <i className="ti ti-calendar" />
                  </span>
                  <h5 className="card-title mb-0">Schedule</h5>
                </div>
              </div>
              <div className="card-body pb-0">
                <CRMCalendar />
              </div>
            </div>
          </div>

          <div className="col-12 col-md-12 col-lg-4 d-flex">
            <div className="card flex-fill">
              <div className="card-header d-flex justify-content-between align-items-center flex-wrap gap-3">
                <div className="d-inline-flex align-items-center">
                  <span className="title-icon bg-soft-orange fs-16 me-2">
                    <i className="ti ti-clock" />
                  </span>
                  <h5 className="card-title mb-0">Latest Project Activity</h5>
                </div>
              </div>
              <div className="card-body">
                <CRMTimeLine />
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="copyright-footer d-flex align-items-center justify-content-between border-top bg-white gap-3 flex-wrap">
        <p className="fs-13 text-gray-9 mb-0">
          2014-2025 © Pereco. All Right Reserved
        </p>
        <p>
          Designed &amp; Developed By Pereco{" "}
          <Link to="#" className="link-primary">
            Pereco
          </Link>
        </p>
      </div>
    </div>
  );
};

export default CRMDashboard;
